// Semantic roles are property-specific; palette values remain in colors.js.
import { colors } from './colors';

export const semanticTokens = {
  color: {
    brand: { light: colors.primary.light[12], dark: colors.grey.dark[12] },
    'control-primary-label': { light: colors.grey.light[1], dark: colors.grey.dark[12] },
    'control-secondary-label': { light: colors.grey.light[12], dark: colors.grey.dark[12] },
    'alert-success': { light: colors.green.light[10], dark: colors.green.dark[2] },
    'alert-warning': { light: colors.yellow.light[9], dark: colors.yellow.dark[9] },
    'alert-critical': { light: colors.red.light[11], dark: colors.red.dark[10] },
    'brand-alt': { dark: colors.primary.dark[11] },
    muted: { light: colors.grey.light[11], dark: colors.grey.dark[11] },
    faint: { light: colors.grey.light[8], dark: colors.grey.dark[8] },
  },
  text: {
    default: { light: colors.grey.light[12], dark: colors.grey.dark[12] },
    muted: { light: colors.grey.light[11], dark: colors.grey.dark[11] },
    faint: { light: colors.grey.light[8], dark: colors.grey.dark[8] },
    link: { light: colors.primary.light[12], dark: colors.primary.dark[11] },
    'link-hover': { light: colors.primary.light[9], dark: colors.primary.dark[10] },
    'alert-success': { light: colors.green.light[10], dark: colors.green.dark[9] },
    'alert-warning': { light: colors.yellow.light[9], dark: colors.yellow.dark[9] },
    'alert-critical': { light: colors.red.light[11], dark: colors.red.dark[10] },
    'alert-critical-hover': { light: colors.red.light[8], dark: colors.red.dark[9] },
    'alert-orange': { light: '#FB923C', dark: '#FB923C' },
  },
  border: {
    base: { light: colors.grey.light[6], dark: colors.grey.dark[6] },
    faint: { light: colors.grey.light[5], dark: colors.grey.dark[5] },
    control: { light: colors.grey.light[8], dark: colors.grey.dark[8] },
    'control-hover': { light: colors.grey.light[9], dark: colors.grey.dark[9] },
    'control-focus': { light: colors.primary.light[12], dark: colors.primary.dark[11] },
    'control-critical': { light: colors.red.light[11], dark: colors.red.dark[10] },
    field: { light: '#E5E7EB', dark: 'rgba(255, 255, 255, 0)' },
    'field-hover': { light: '#D1D5DB', dark: 'rgba(255, 255, 255, 0.15)' },
    alert: { light: colors.overlay.light[3], dark: colors.overlay.dark[4] },
    'alert-success': { light: colors.green.light[10], dark: colors.green.dark[9] },
    'alert-warning': { light: colors.yellow.light[9], dark: colors.yellow.dark[9] },
    'alert-critical': { light: colors.red.light[11], dark: colors.red.dark[10] },
  },
  bg: {
    base: { light: colors.grey.light[1], dark: colors.grey.dark[2] },
    hover: { light: colors.grey.light[3], dark: colors.grey.dark[4] },
    'hover-faint': { light: colors.grey.light[2], dark: colors.grey.dark[3] },
    selected: { light: colors.primary.light[3], dark: colors.primary.dark[6] },
    'selected-hover': { light: colors.primary.light[5], dark: colors.primary.dark[7] },
    'selected-faint': { light: colors.primary.light[1], dark: colors.primary.dark[2] },
    'selected-hover-faint': { light: colors.primary.light[2], dark: colors.primary.dark[3] },
    shade: { light: colors.grey.light[3], dark: colors.grey.dark[3] },
    'shade-hover': { light: colors.grey.light[6], dark: colors.grey.dark[6] },
    sub: { light: colors.grey.light[2], dark: colors.grey.dark[1] },
    'site-bg': { light: colors.grey.light[3], dark: colors.grey.dark[1] },
    'header-bg': { light: `#252441`, dark: colors.grey.dark[2] },
    'control-primary': { light: colors.primary.light[12], dark: colors.primary.dark[9] },
    'control-primary-hover': { light: colors.primary.light[11], dark: colors.primary.dark[8] },
    'control-active': { light: colors.primary.light[6], dark: colors.primary.dark[9] },
    'control-secondary': { light: colors.grey.light[2], dark: colors.grey.dark[6] },
    'control-secondary-hover': { light: colors.grey.light[3], dark: colors.grey.dark[7] },
    field: { light: '#F3F4F6', dark: 'rgba(255, 255, 255, 0.05)' },
    'alert-success': { light: colors.green.light[4], dark: colors.green.dark[6] },
    'alert-success-hover': { light: colors.green.light[5], dark: colors.green.dark[7] },
    'alert-warning': { light: colors.yellow.light[4], dark: colors.yellow.dark[8] },
    'alert-warning-hover': { light: colors.yellow.light[5], dark: colors.yellow.dark[9] },
    'alert-critical': { light: colors.red.light[4], dark: colors.red.dark[5] },
    'alert-critical-hover': { light: colors.red.light[5], dark: colors.red.dark[6] },
  },
};
